<template>
  <BaseCard
    class="tw:mb-6 tw:flex tw:flex-col tw:gap-8 tw:md:flex-row tw:md:justify-between tw:md:items-center tw:text-sm"
  >
    <div class="tw:md:max-w-2xl">
      <h3 class="tw:text-xl tw:font-bold tw:mb-4">{{ $t('rc_markets_header') }}</h3>
      <p>{{ $t('rc_markets_subtext') }}</p>
    </div>
    <div class="tw:flex tw:gap-6 tw:items-center tw:justify-between">
      <div class="tw:max-w-[220px]">
        <strong>{{ $t('rc_markets_auto_header') }}</strong>
        <p>{{ $t('rc_ams_subtext') }}</p>
      </div>
      <MainSwitch :value="isUsingAutomatedMarkets" :disabled="isSwitchingAMS" @onClick="onUpdateAutomatedMarkets" />
    </div>
  </BaseCard>
  <FullScreenLoader v-show="isSwitchingAMS" />
</template>

<script setup>
import BaseCard from '@/components/dashboard/BaseCard.vue'
import MainSwitch from '@/components/base/switches/MainSwitch.vue'
import FullScreenLoader from '@/components/base/loaders/FullScreenLoader.vue'
import { useCampaign, useCampaignMutation } from '@/components/rateConnect/queries'
import useToastNotifications from '@/components/notifications/useToastNotifications'
import { selectedAccommodationId } from '@/layouts/queries'

const { displayNotification, showSaveError } = useToastNotifications()

const { isUsingAutomatedMarkets } = useCampaign(selectedAccommodationId)
const { switchingAMS, isSwitchingAMS } = useCampaignMutation()

const onUpdateAutomatedMarkets = () => {
  const successMessage = isUsingAutomatedMarkets.value
    ? 'rc_markets_manual_success_message'
    : 'rc_markets_auto_success_message'
  switchingAMS(
    {
      accommodationId: selectedAccommodationId.value,
      body: { switchState: isUsingAutomatedMarkets.value ? 'OFF' : 'ON' },
    },
    {
      onSuccess: () => {
        displayNotification({
          message: successMessage,
          isTranslationKey: true,
          type: 'success',
        })
      },
      onError: () => {
        showSaveError()
      },
    }
  )
}
</script>
